import React from 'react'
import {connect} from 'react-redux'
import {string, bool, func, oneOf, shape, number} from 'prop-types'
import {InputField} from '@agillic/agillic-ui'

import {
  onKeyDownHandler,
  passwordPlaceholder,
  onChangeHandler,
  arePasswordsDisabled,
  isAutofocus
} from '../inputFields.helper'
import {validatePasswordInput} from '../inputFields.validation'

import {setPasswordDirty, updatePassword} from '../../login.actionCreators'
import {language, loginModesList} from '../../helpers/login.data'
import localeData from '../../helpers/login.lang'

const locale = localeData[language]

const Password = ({isVisible, password, onUpdatePassword, isPasswordDirty, passwordPolicy, wasExistingPasswordUsed, isAuthInProgress, mode, isPasswordPolicyPending, onSubmit, onSetPasswordDirty}) => isVisible && (
  <InputField
    inputType='password'
    label={locale.password()}
    placeholder={passwordPlaceholder({mode})}
    value={password}
    onBlur={() => onSetPasswordDirty()}
    onChange={({target}) => onChangeHandler({target, onUpdate: onUpdatePassword})}
    validation={validatePasswordInput({password, isPasswordDirty, passwordPolicy, mode, wasExistingPasswordUsed})}
    isDisabled={arePasswordsDisabled({isAuthInProgress, isPasswordPolicyPending})}
    uniqueID='password'
    onKeyDown={({key}) => onKeyDownHandler({key, onSubmit})}
    autofocus={isAutofocus({mode, field: 'password'})}
  />
)

const mapStateToProps = ({loginReducer}) => ({
  isAuthInProgress: loginReducer.isAuthInProgress,
  mode: loginReducer.mode,
  isPasswordPolicyPending: loginReducer.isPasswordPolicyPending,
  password: loginReducer.password,
  isPasswordDirty: loginReducer.isPasswordDirty,
  passwordPolicy: loginReducer.passwordPolicy,
  wasExistingPasswordUsed: loginReducer.wasExistingPasswordUsed
})

const mapDispatchToProps = dispatch => ({
  onUpdatePassword: value => dispatch(updatePassword(value)),
  onSetPasswordDirty: isDirty => dispatch(setPasswordDirty(isDirty))
})

Password.propTypes = {
  isVisible: bool,
  isAuthInProgress: bool,
  mode: oneOf(loginModesList),
  isPasswordPolicyPending: bool,
  password: string,
  onUpdatePassword: func.isRequired,
  isPasswordDirty: bool,
  passwordPolicy: shape({
    minLength: number,
    minLowercase: number,
    minUpperCase: number,
    minNumbers: number,
    minSpecial: number
  }),
  onSubmit: func.isRequired,
  wasExistingPasswordUsed: bool
}

export default connect(mapStateToProps, mapDispatchToProps)(Password)
